// Site branding + team meta (short codes, names, colours) used across the UI.
export const SITE = {
  name: "BatBallWorld",
  tagline: "Live Cricket. Real Odds. Play Smart.",
  domain: "batballworld.com",
};

export const TEAMS = {
  IND: { code: "IND", name: "India", color: "#1e60d1" },
  AUS: { code: "AUS", name: "Australia", color: "#f6c000" },
  ENG: { code: "ENG", name: "England", color: "#0a5cbe" },
  PAK: { code: "PAK", name: "Pakistan", color: "#0f9d58" },
  SA: { code: "SA", name: "South Africa", color: "#0b8f4e" },
  NZ: { code: "NZ", name: "New Zealand", color: "#111827" },
  SL: { code: "SL", name: "Sri Lanka", color: "#0b4aa2" },
  WI: { code: "WI", name: "West Indies", color: "#7a0e1c" },
  BAN: { code: "BAN", name: "Bangladesh", color: "#036b3f" },
  AFG: { code: "AFG", name: "Afghanistan", color: "#1c6fb8" },
};

export const NEWS_TICKER = [
  { date: "Today", text: "Live session & lambi lines now update instantly — no refresh needed." },
  { date: "Bonus", text: "Weekly losing bonus — 10% cashback on your net weekly losses." },
  { date: "Fast", text: "Quick bank deposits & superfast withdrawals, 24/7 support." },
  { date: "Note", text: "During technical issues, the win/lose result of a placed bet stands." },
];
